import { observable, action } from "mobx"
import _ from "lodash"

class CollectionStore {
  @observable focusedCollection
  @observable availableCollections = []
  @observable visibleCollections = []

  @action
  setFocusedCollection = (collectionId) => {
    this.focusedCollection = this.availableCollections.find((c) => c.id === collectionId)
  }

  @action
  clearFocusedCollection = () => {
    this.focusedCollection = null
  }

  @action
  addUniqueAvailableCollection = (collection) => {
    const duplicateCollection = _.find(this.availableCollections, function(c) { return c.id === collection.id })

    if (!duplicateCollection) {
      this.availableCollections.push(collection)
    }
  }
}

export default new CollectionStore()
